angular.module("Main").directive("vMobile", vMobile);

function vMobile() {
    return {
        restrict: "A",
        require: "ngModel",
        link: function (scope, element, attr, ngModel) {
            var validationFunction = function (viewValue) {
                var valid = (!_.isNil(viewValue) && validator.isMobilePhone(viewValue));
                ngModel.$setValidity("vMobile", valid);

                return viewValue;
            };

            ngModel.$parsers.unshift(validationFunction);
            ngModel.$formatters.unshift(validationFunction);
        }
    }
}